const ArrowLeft = ({ className = "w-5 h-5",stroke="1.5" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={stroke} className={className} stroke="currentColor">
  <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
</svg>
    );
  };
  
  export default ArrowLeft;
